/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./forward.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./forward.component";
import * as i3 from "@angular/router";
var styles_ForwardComponent = [i0.styles];
var RenderType_ForwardComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ForwardComponent, data: {} });
export { RenderType_ForwardComponent as RenderType_ForwardComponent };
export function View_ForwardComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_ForwardComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-forward", [], null, null, null, View_ForwardComponent_0, RenderType_ForwardComponent)), i1.ɵdid(1, 114688, null, 0, i2.ForwardComponent, [i3.Router], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ForwardComponentNgFactory = i1.ɵccf("app-forward", i2.ForwardComponent, View_ForwardComponent_Host_0, {}, {}, []);
export { ForwardComponentNgFactory as ForwardComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/core/forward/forward.component.ngfactory.js.pre-build-optimizer.js